interface Props {
  history: string[];
  onClear: () => void;
}
const HistoryPanel: React.FC<Props> = ({ history, onClear }) => (
  <div className="history-section">
    <h3>History</h3>
    <button className="clear-history" onClick={onClear}>Clear</button>
    {history.map((item, idx) => (
      <div key={idx} className="history-item">{item}</div>
    ))}
  </div>
);
export default HistoryPanel;
